import { DuplicatedJobTable } from '../Scraping/components/DuplicatedJobTable/DuplicatedJobTable';
import { SCRAPING_JOB_STATUS } from '../Scraping/types';

export const BaseTableTest = () => {
  return (
    <div>
      <DuplicatedJobTable
        data={[
          {
            alias: '123',
            title: 'Test',
            end_date: '2025-01-01',
            start_date: '2025-01-01',
            status: SCRAPING_JOB_STATUS.COMPLETED,
            feedback_count: 100,
          },
          {
            alias: '234',
            title: 'Test2',
            end_date: '2025-01-01',
            start_date: '2025-01-01',
            status: SCRAPING_JOB_STATUS.COMPLETED,
            feedback_count: 100,
          },
          {
            alias: '345',
            title: 'Test3',
            end_date: '2025-01-01',
            start_date: '2025-01-01',
            status: SCRAPING_JOB_STATUS.RUNNING_SCRAPING,
            feedback_count: 0,
          },
        ]}
        onExternalLinkClick={() => {}}
      />
    </div>
  );
};
